import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

/** @deprecated Use `Dialog` from `@crono-one/design-system` instead */
export const BlurBackgroundDivFixed = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${colors.black}66;
  z-index: 5000;
`;

/** @deprecated Use `Dialog` from `@crono-one/design-system` instead */
export const BlurBackgroundDivAbsolute = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${colors.black}66;
  z-index: 5000;
`;
